import { Component, Input, OnInit } from '@angular/core';

import { WikiService } from '../services/wiki.service';
import { UserService } from '../../../core/services/core.user.service';

import * as _ from 'lodash';

@Component({
    selector: 'public-wiki',
    template: `<a id="wikiPagePublic" *ngIf="showPublic" class="btn"
    title="{{'Toggle public / private' | translate}}"
    (click)="togglePublic()"
    [ngClass]="{ 'btn-success': wikiPage.rel.options.isPublic == 'Y', 'btn-trans': wikiPage.rel.options.isPublic != 'Y' }">
    <i class="glyphicon glyphicon-globe"></i>
</a>
`
})
export class PublicWikiComponent implements OnInit {

    @Input() project: any;
    @Input() wikiPage: any;

    private public: any;
    protected showPublic: boolean;

    constructor(
        private wikiService: WikiService,
        private userService: UserService
    ) { }

    ngOnInit() {
        this.public = {
            isPublic: _.get(this.wikiPage, 'rel.options.isPublic', 'N')
        };

        const isProjectAdmin = _.get(this.project, 'rel.permissions.admin', false);
        const isWikiAdmin = _.get(this.project, 'rel.permissions.wiki', 0) >= 99;
        this.showPublic =
            this.userService.session.hasUser() &&
            (isProjectAdmin || isWikiAdmin) &&
            _.get(this.wikiPage, 'id', false);
    };

    togglePublic = () => {
        var oldPublic = _.get(this.wikiPage, 'rel.options.isPublic', 'Y');
        var newPublic = oldPublic == 'Y' ? 'N' : 'Y';
        const wikiId = this.wikiPage?.id ?? null;
        var projectRef = _.get(this.project, 'id', _.get(this.project, 'projectId', this.project?.unixName ?? null));
        if (!projectRef || !wikiId) {
            return;
        }

        _.set(this.wikiPage, 'rel.options.isPublic', newPublic);
        this.wikiService.postOptions(wikiId, { project: projectRef, isPublic: newPublic })
            .catch((result) => {
                _.set(this.wikiPage, 'rel.options.isPublic', oldPublic);
                console.log('togglePublic', result);
            });
    };
}